import axios from "axios";

const API_URL = "https://api.suuplink.suave.ppg.br/api/";

const requestCoverUpload = async ({ coverData, admin, idId, method }) => {
  return await axios({
    method,
    url: API_URL + `admin/pages/${idId}/upload-cover`,
    data: coverData,
    headers: {
      "x-access-token": admin.accessToken,
    },
  });
};

const putCover = async ({ coverData, admin, idId }) => {
  try {
    return await requestCoverUpload({ coverData, admin, idId, method: "put" });
  } catch (error) {
    if (error?.response?.status === 404) {
      return await requestCoverUpload({
        coverData,
        admin,
        idId,
        method: "post",
      });
    }

    throw error;
  }
};

const coverService = {
  putCover,
};

export default coverService;
